module.exports = __webpack_public_path__ + "static/media/galerija_2019 (23).9f4933e9.jpg";